import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'blaze-chat-empty-state',
  templateUrl: './chat-empty-state.component.html',
  styleUrls: ['./chat-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class ChatEmptyStateComponent {
  readonly disabled = input<boolean>(false);
  readonly showAddButton = input.required<boolean>();
  readonly hasConversations = input.required<boolean>();
  readonly menuVisible = input.required<boolean>();
  readonly createNewConversation = output<void>();
  readonly openMenu = output<void>();

  readonly title = computed(() =>
    this.hasConversations() ? 'Select a conversation' : 'No conversations yet',
  );

  readonly description = computed(() => {
    if (this.hasConversations()) {
      return this.showAddButton()
        ? 'Pick one from the list or start a new one.'
        : 'Pick a conversation from the list to get started.';
    }

    return this.showAddButton()
      ? 'Start a new conversation to begin chatting.'
      : 'You don’t have any conversations.';
  });
}
